import { useContext } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';
import { CouponStoreContext } from '../components/CouponStoreContext.js';
/**
 * Returns the raw coupon store.
 *
 * @returns Raw Zustand coupon store
 * @throws {Error} if the hook is used outside of the CouponStoreProvider
 */
export function useRawCouponStore() {
  const couponStoreContext = useContext(CouponStoreContext);
  if (!couponStoreContext) {
    throw new Error("useCouponStore must be used within CouponStoreProvider");
  }
  return couponStoreContext;
}
/**
 * Returns the coupon store.
 *
 * @param selector Zustand store selector
 * @returns Zustand coupon store
 */
export function useCouponStore(selector) {
  const couponStoreContext = useRawCouponStore();
  return useStore(couponStoreContext, useShallow(selector));
}